import { Component, Input, SimpleChanges } from "@angular/core";
import { IFilterOptions } from "@app/interfaces/filters/IFilterOptions";
import { DynamicReportService } from "@app/main/components/reports/_services/dynamicReports.service";
import { IDataDefinition } from "@app/main/components/reports/models/IReportDefinition";
import { IDashboardWidget } from "@app/main/modules/dashboard/_models/IDashboardWidget";
import copy from "fast-copy";
import { DashboardService } from "../../dashboard.service";
import './table-widget.component.scss';

@Component({
    selector: 'v-table-widget',
    template: require('./table-widget.component.html')
})
export class VTableWidgetComponent {
    @Input() widget: IDashboardWidget;
    @Input() filterOptions: IFilterOptions;
    @Input() report: IDataDefinition;

    constructor(
        private readonly dashboardService: DashboardService,
        private readonly dynamicReportService: DynamicReportService
    ) { }

    ngOnInit(): void {
        this.widget.onDataDefinitionUpdated = () => { this.updateDisplay(); };

        this.dashboardService.dataSourceToWidgetDataDefinition(this.widget);
        this.dynamicReportService.filtersToDefinition(this.filterOptions, this.widget.dataDefinition);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["filterOptions"] && !changes["filterOptions"].isFirstChange()) {
            this.updateDisplay();
        }
    }

    //-

    private updateDisplay(): void {
        this.report = copy(this.widget.dataDefinition);
    }
}
